import React, { useEffect, useState } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";

const TransactionTable = ({
  data,
  selectedStatus,
  handleStatusChange,
  loading,
}: any) => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const columns = [
    // { header: "Order ID", accessor: "orderId" },
    { header: "Email", accessor: "email" },
    { header: "Reference", accessor: "reference" },
    { header: "Status", accessor: "status" },
    { header: "Amount", accessor: "amount" },
    { header: "Date", accessor: "created_at" },
    { header: " ", accessor: "id" },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      const filtered = data.filter((user: any) => {
        if (selectedStatus === "") return true;
        return user.status.toLowerCase() === selectedStatus.toLowerCase();
      });
      setFilteredData(filtered);
      setIsLoading(false);
    }, 1000); 

    return () => clearTimeout(timer);
  }, [data, selectedStatus]);

  const handleUserClick = (id: string) => {
    navigate(`/transaction/details/${id}`);
  };

  const mappedData = filteredData.map((transaction: any) => ({
    ...transaction,
    // orderId: transaction?.order?.orderId || "N/A",
    Email: transaction?.order?.buyerEmail || "N/A",
    merchantEmail: transaction?.order?.merchantEmail || "N/A",
  }));

  return (
    <div className="rounded-md py-3 px-3 bg-white border border-[#fff] mt-10 w-[95%] pt-5 ">
      <div className="flex justify-between">
        <p className="text-[18px] font-semibold">All transactions</p>
        <div className="flex gap-2">
          <span className="text-[14px] font-medium">Filter by: </span>
          <select
            className="border text-[12px] px-3 py-1 rounded bg-[#0979A1] text-white"
            value={selectedStatus}
            onChange={handleStatusChange}
          >
            <option value="">All</option>
            <option value="successful">Successful</option>
            <option value="pending">Pending</option>
            <option value="failed">Failed</option>
          </select>
        </div>
      </div>

      {loading || isLoading ? (
        <div className="flex justify-center items-center h-64">
          <TailSpin color="skyblue" />
        </div>
      ) : filteredData.length > 0 ? (
        <Table
          columns={columns}
          data={mappedData}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500 text-lg">No data available</p>
        </div>
      )}
    </div>
  );
};

export default TransactionTable;
